/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getSafetyFroms } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { format } from "date-fns";
import { useSearchParams } from "react-router-dom";

const Safety = () => {
  const { state } = useAuth();
  const [loading, setLoading] = useState(true);
  const [searchParams,] = useSearchParams();

  const [safetyData, setSafetyData] = useState<any>([]);

  const getSafetydata = async () => {
    try {
      const response = await getSafetyFroms(state.user?.token, searchParams.get('workerId'));
      setSafetyData(response?.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSafetydata();
  },[]);

  const columns: any = [
    {
      field: "title",
      headerName: "Type",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      renderCell: (params: any) => (
        <div>
          {params.row.status === 1 ? (
            <span style={{ color: "red", fontWeight: "bold" }}>Missed</span>
          ) : (
            <span style={{ color: "green", fontWeight: "bold" }}>Submitted</span>
          )}
        </div>
      ),
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 0.5,
      renderCell: (params: any) => (
        <div>
          {format(new Date(params.row.dateSubmitted || Date.now()), 'dd/MM/yyyy')}
        </div>
      ),
    },
  ];

  return (
    <Box
      sx={{
        p: 1,
        height: '100%',
        minHeight: '100vh'
      }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: '16px',
          backgroundColor: '#ffffff',
          maxWidth: '1200px',
          margin: '0 auto'
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: '740px',
            margin: "0 auto",
            "@media (max-width: 800px)": {
              overflowX: "auto",
              margin: 1,
              minWidth: "95%",
            },
          }}
        >
          <DataGrid
            rows={safetyData}
            columns={columns}
            disableRowSelectionOnClick
            loading={loading}
            sx={{
              "@media (max-width: 700px)": {
                minWidth: "100%",
              },
              "& .MuiDataGrid-columnHeader": {
                color: "#333",
                fontWeight: "bold",
                fontSize: 15,
                backgroundColor: '#f0f0f0',
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f1f1f1",
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Safety;
